import { useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const links = [
    { label: t.nav.services, href: "#services" },
    { label: t.nav.about, href: "#about" },
    { label: t.nav.testimonials, href: "#testimonials" },
    { label: t.nav.contact, href: "#contact" },
  ];
  return (
    <footer className="border-t border-white/10 pt-20 pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <p className="font-display font-black uppercase tracking-tighter text-[clamp(3rem,12vw,10rem)] leading-none text-stroke select-none" aria-hidden="true">
          IP NET
        </p>
        <div className="mt-12 flex flex-col md:flex-row md:items-center justify-between gap-8 border-t border-white/10 pt-8">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500">
            © {new Date().getFullYear()} {t.footer.rights}
          </p>
          <nav className="flex flex-wrap gap-8" data-testid="footer-nav">
            {links.map((l) => (
              <a key={l.href} href={l.href} data-testid={`footer-link-${l.href.slice(1)}`} className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-500 hover:text-white transition-colors duration-300">
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
